import { render } from "./GeneralDataConfig.vue?vue&type=template&id=3f25e858&scoped=true"
import script from "./GeneralDataConfig.vue?vue&type=script&lang=js"
export * from "./GeneralDataConfig.vue?vue&type=script&lang=js"

import "./GeneralDataConfig.vue?vue&type=style&index=0&id=3f25e858&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f25e858"],['__file',"src/components/admin/GeneralDataConfig.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f25e858"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f25e858', __exports__)) {
    api.reload('3f25e858', __exports__)
  }
  
  module.hot.accept("./GeneralDataConfig.vue?vue&type=template&id=3f25e858&scoped=true", () => {
    api.rerender('3f25e858', render)
  })

}


export default __exports__